import React from 'react';
import clsx from 'clsx';
import Icon from '../Icon';
import { useTheme } from '../../contexts/ThemeContext';

const Topbar = ({ environment, setEnvironment, lastUpdated, onMobileMenu }) => {
  const { theme, toggle } = useTheme();

  const formatTime = (date) =>
    date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit' });

  const isTestnet = environment === 'testnet';

  return (
    <header className={clsx('app-topbar topbar', isTestnet && 'testnet')}>
      <button
        type="button"
        className="icon-btn topbar-mobile-toggle"
        aria-label="Open menu"
        onClick={onMobileMenu}
      >
        <Icon name="menu" />
      </button>

      <div className="topbar-meta">
        <span className="live-dot" />
        <span className="topbar-meta-text">&nbsp;Live · last sync <strong>{formatTime(lastUpdated)}</strong></span>
      </div>

      <div className="topbar-spacer" />

      <div className="topbar-actions">
        <div className="env-toggle" role="tablist" aria-label="Environment">
          <button
            type="button"
            role="tab"
            className={clsx(environment === 'mainnet' && 'active')}
            onClick={() => setEnvironment('mainnet')}
            aria-selected={environment === 'mainnet'}
          >
            Mainnet
          </button>
          <button
            type="button"
            role="tab"
            className={clsx(environment === 'testnet' && 'active testnet')}
            onClick={() => setEnvironment('testnet')}
            aria-selected={environment === 'testnet'}
          >
            Testnet
          </button>
        </div>

        <button
          type="button"
          className="icon-btn"
          onClick={toggle}
          aria-label={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
          title={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
        >
          <Icon name={theme === 'dark' ? 'sun' : 'moon'} size={18} />
        </button>

        <div className="avatar" aria-label="Stanford">S</div>
      </div>
    </header>
  );
};

export default Topbar;
